'use client';

import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import React from 'react';

import {Button} from '@/components/ui/button';
import { safeRedirectPath } from '@/shared/utils/postAuthRedirect';

interface UnAuthenticatedUserModalProps {
    onClose?: () => void;
    modalId?: string;
}

export const UnAuthenticatedUserModal: React.FC<UnAuthenticatedUserModalProps> = ({
                                                                                      onClose,
                                                                                  }) => {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const query = searchParams.toString();
    const hash = typeof window === 'undefined' ? '' : window.location.hash;
    const returnPath = safeRedirectPath(`${pathname}${query ? `?${query}` : ''}${hash}`);
    const redirectQuery = returnPath ? `?redirect=${encodeURIComponent(returnPath)}` : '';

    return (
        <div className="p-6">
            <div className="my-6 w-full space-y-4">
                <h3 className="text-center font-sans text-[38px] font-extrabold leading-[48px] text-motitoBlack">
                    Create an account to continue
                </h3>

                <p className="mt-6 pt-4 text-center leading-[24px]">
                    Thank you for choosing Motito PayLater. Register or log in to
                    complete your order with Motito.
                </p>
            </div>

            <div className="flex flex-col items-center justify-center gap-y-2">
                <Link href={`/sign-up${redirectQuery}`} className="w-full" onClick={onClose}>
                    <Button
                        size="lg"
                        className="w-full rounded-full bg-motitoBlue text-white"
                    >
                        Create an account
                    </Button>
                </Link>

                <p className="relative inline-block text-base leading-[24px] text-black-100">
                    OR
                </p>

                <Link href={`/sign-in${redirectQuery}`} className="w-full" onClick={onClose}>
                    <Button
                        size="lg"
                        variant="outline"
                        className="w-full rounded-full"
                    >
                        Log in
                    </Button>
                </Link>
            </div>
        </div>
    );
};

UnAuthenticatedUserModal.displayName = 'UnAuthenticatedUserModal';

export default UnAuthenticatedUserModal;
